
const state = {
  data: {},
  id: null,
  is_free: false,
  is_prepaid: false,
  title: '',
}

export const requiredFields = [
  { key: 'title' },
]

export default state
